import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import {
    Box, styled
} from '@mui/material';
import Tab from '@mui/material/Tab';
import { useEffect, useState } from 'react';
import { apiService } from '../../api/axiosClient';
import TableMyOrder from 'src/views/order/TableMyOrder';
import TableRecentView from './TableRecentView';

const TabsWrapper = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '1.5rem',
    borderBottom: 1, 
    borderColor: 'divider'
});

const MemberInfo = ({username}) => {
    const [recentView, setRecentView] = useState([])
    const [tabs, setTabs] = useState('1');

    const getRecentViewList = async (username) => {
        await apiService.get(`/recentview/latest/${username}`)
        .then(response => {
            setRecentView(response.data.list)
        })
    }

    useEffect(() => {
        getRecentViewList(username);
    }, [username]);

    const handleChange = (e, newValue) => {
        e.preventDefault()        
        setTabs(newValue);
    };

    return (
        <Box sx={{ width: '100%',  }}>
            <TabContext value={tabs}>
                <TabsWrapper>
                    <TabList onChange={handleChange} aria-label="lab API tabs example">
                        <Tab label="주문내역" value="1" />
                        <Tab label="최근 본 상품" value="2" />
                    </TabList>
                </TabsWrapper>
                <TabPanel value="1">
                {
                    username && <TableMyOrder username={username} />
                }
                </TabPanel>
                <TabPanel value="2">
                {
                    <TableRecentView list={recentView} />
                }
                </TabPanel>
            </TabContext>
        </Box>
    )
}

export default MemberInfo